import { PRIMARYCARE_PAGETYPE_TEMPLATE_ID } from 'lib/constants';
import { LocationItem } from '../../../types/provider-items';
import { guidsAreEqual } from './string-utils';

// Verifies whether a list of locations includes one or more primary care locations using the field PageType
export const hasPrimaryCareLocation = (locations: LocationItem[] | undefined): boolean => {
  const validLocations = (locations || []) as LocationItem[];
  return validLocations?.some((location) =>
    guidsAreEqual(location?.fields?.PageType?.id, PRIMARYCARE_PAGETYPE_TEMPLATE_ID)
  );
};
